<template>
    <v-footer app>
        <div class="d-flex py-2 justify-between">
            <div class="d-flex align-center">
                <v-btn text href="https://agrolink.com.ua" target="_blank" class="mr-2">Agrolink</v-btn>
                <span class="mr-2">© {{ new Date().getFullYear() }}</span>
            </div>


        </div>
    </v-footer>
</template>

<script>
export default {
    name: "Footer"
}
</script>

<style scoped></style>
